<template>
<div id="contents">

  <div id="works" class="page_contents">

    <div id="works_contents">
      <div id="works_event_show" v-if="event_item">

        <div id="works_event_show_main" class="page_main_contents">
          <h1 v-bind:class="{ 'new' : event_item.is_new }">{{ event_item.title }}</h1>
          <p id="works_event_show_main_img"><img :src="event_item.mainimg" width="" alt="番組のロゴ" /></p>
          <p class="page_close hover"><router-link v-bind:to="{name: 'event_index'}"><img src="../assets/img/common/page/close_icon.png" width="55" alt="閉じるボタン" ></router-link></p>
        </div><!-- #works_program_show_main -->

        <div id="works_event_show_body" class="page_main_contents">
          <div id="works_event_show_body_contents" v-html="event_item.content"></div><!-- #works_event_show_body_contents -->

          <div id="works_event_show_body_info">
            <dl class="clearfix">
              <dt v-if="event_item.day01">【開催期間】</dt>
              <dd v-if="event_item.day01">{{ event_item.day01 }} ～ {{ event_item.day02 }}</dd>

              <dt v-if="event_item.website">【公式ページ】</dt>
              <dd v-if="event_item.website" class="official_link"><a :href="event_item.website" traget="_blank">{{ event_item.website }}</a></dd>

              <dt v-if="event_item.address">【場所】</dt>
              <dd v-if="event_item.address" v-html="event_item.address"></dd>

              <dt v-if="event_item.sponsor">【主催】</dt>
              <dd v-if="event_item.sponsor" v-html="event_item.sponsor"></dd>

              <dt v-if="event_item.pay">【料金】</dt>
              <dd v-if="event_item.pay" v-html="event_item.pay"></dd>

              <dt v-if="event_item.abouttext">【詳細説明】</dt>
              <dd v-if="event_item.abouttext" v-html="event_item.abouttext"></dd>
            </dl>

            <p v-if="event_item.is_old" class="end_text">このイベントは終了いたしました。</p>
          </div><!-- #works_event_show_body_info -->

        </div><!-- #works_event_show_body -->

        <ul id="page_nav">

          <p  class="hover" v-if="event_item.next_post_id"><router-link v-bind:to="{name: 'event_show', params: {id: event_item.next_post_id}}"><img src="../assets/img/common/page/arrow.png" width="20" alt="右矢印" ></router-link></p>
          <p v-else></p>

          <p  class="hover" v-if="event_item.prev_post_id"><router-link v-bind:to="{name: 'event_show', params: {id: event_item.prev_post_id}}"><img src="../assets/img/common/page/arrow.png" width="20" alt="左矢印" ></router-link></p>
          <p v-else></p>

        </ul><!-- #page_nav -->

      </div><!-- #works_event_show -->
    </div><!-- #works_contents -->
  </div><!-- #works -->



</div><!-- #contents -->
</template>

<script>
export default {
  name: 'event_show',
  data() {
    return {
      api_url: this.$parent.api_base_url+'/api/event/show.php',
      event_item: null,
      error: null
    }
  },
  methods: {
    fetch_event(){
      this.$axios
        .get(this.api_url ,{
          params: {
            id: this.$route.params.id
          }
        })
        .then(response => {
          this.event_item = response.data.item[0]
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally()
    }
  },
  watch: {
    '$route' (to, from) {
      this.fetch_event()
    }
  },
  mounted () {
    this.fetch_event()
  },
  updated (){
    var queue = new createjs.LoadQueue(true);
    const ts = this;
    queue.loadManifest([this.event_item.mainimg],true);
    queue.addEventListener("complete",function(){
      ts.$emit('page_fade')
    });
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/event_show.vue